import { UpdateWorkOrderDto } from '../request-models/update-work-order-dto.model';
import { WorkOrderRequest } from '../request-models/work-order-request.model';
import { omitUndefined } from './wire-value-utils';

/**
 * Builds the hub request body from a work-order form DTO. Sends only the allowlisted fields that are set,
 * so an update stays partial. `null` (clear the field) is kept; only `undefined` is dropped.
 */
export function toWorkOrderRequest(dto: UpdateWorkOrderDto): WorkOrderRequest {
  return omitUndefined<WorkOrderRequest>({
    title: dto.title,
    description: dto.description,
    customerId: dto.customerId,
    fieldId: dto.fieldId,
    assignedPilotProfileId: dto.assignedPilotProfileId,
    scheduledDate: dto.scheduledDate,
    scheduledTime: dto.scheduledTime,
  });
}
